<template>
  <div class="w-100 h-100 d-flex flex-column align-items-stretch">
    <div class="simple-page-navbar" :style="`background-color: #${cityColor}`">
      <div class="container d-flex flex-row align-items-center gap-5">
        <CityButton responsive :city="city" class="p-3 text-uppercase me-auto" :icon-size="48" include-state>
          {{ title }}
        </CityButton>
        <a v-if="city?.admin.url" :href="safeHref(city?.admin.url)" class="d-none d-md-block">
          Homepage
        </a>
        <a v-if="city?.admin?.helpEmail" :href="safeHref(`mailto:${city?.admin?.helpEmail}`)" class="d-none d-md-block">
          Contact
        </a>
      </div>
    </div>
    <div class="flex-grow-1 overflow-hidden">
      <div class="w-100 h-100 overflow-hidden">
        <div class="w-100 h-100 d-flex flex-column align-items-center overflow-hidden">
          <div class="container d-flex flex-column h-100 overflow-hidden p-0 p-md-3">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 p-3 d-flex flex-row align-items-center justify-content-center gap-3 small bg-light">
      <s-t-r-copyright />
      <a href="mailto:info@strenforcement.com">
        <span>Contact</span>
        <span class="d-none d-md-inline"> Us</span>
      </a>
      <a href="/privacy">
        <span>Privacy</span>
        <span class="d-none d-md-inline"> Policy</span>
      </a>
    </div>
  </div>
</template>

<script>
import { safeHref } from '@/safeRendering';
import {City} from "@/models/City";
import CityButton from "@/components/common/CityButton.vue";
import STRCopyright from "@/homepage/STRCopyright.vue";

export default {
  methods: {
    safeHref
  },
  components: {STRCopyright, CityButton},
  props: {
    city: City,
    title: String
  },
  computed: {
    cityColor() {
      return (this.city && this.city.backgroundColor) || '333333';
    }
  }
}
</script>

<style>
.simple-page-navbar a {
  color: var(--bs-white);
  text-decoration: none;
}
</style>
